// GENERATED FILE — do not edit by hand.
// Overwritten at build time by scripts/generate-version.js.
export const APP_VERSION = '841444164db7cae4d90eb9f17647be6012bd5cf2';
export const BUILD_NUMBER = '216';
export const BUILD_TIMESTAMP = '2026-08-14T03:03:14.351Z';
